// extracted by mini-css-extract-plugin
export default {"newRuleButton":"newRuleButton_vSMHR","rulesContainer":"rulesContainer_ohAAz","ruleItem":"ruleItem_xgELX","title":"title_H0Z2C","ruleSwitch":"ruleSwitch_XphNC","extra":"extra_d00FY"};